// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveBonus_base--2WtV9","base__toolbarLayout":"ReserveBonus_base__toolbarLayout--2TiWO","baseToolbarLayout":"ReserveBonus_base__toolbarLayout--2TiWO","base__tooltipLayout":"ReserveBonus_base__tooltipLayout--1L6cF","baseTooltipLayout":"ReserveBonus_base__tooltipLayout--1L6cF"};


//////////////////
// WEBPACK FOOTER
// ./components/ReserveBonus/ReserveBonus.scss
// module id = 390
// module chunks = 11 13